import { motion } from 'framer-motion';
import { useCallback, useContext, useEffect, useState } from 'react';
import { FaPlus } from 'react-icons/fa6';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Context from '../context';
import addToCart from '../helpers/addToCart';
import displayNPRCurrency from '../helpers/displayCurrency';
import fetchCategoryWiseProduct from '../helpers/fetchCategoryWiseProduct';
import scrollTop from '../helpers/scrollTop';

const CategroyWiseProductDisplay = ({ category, heading }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const loadingList = new Array(4).fill(null);
    const { user, isLoading: userLoading } = useSelector(state => state?.user);
    const { fetchUserAddToCart } = useContext(Context);

    const handleAddToCart = async (e, id) => {
        await addToCart(e, id);
        fetchUserAddToCart();
    };

    const fetchData = useCallback(async () => {
        setLoading(true);
        const categoryProduct = await fetchCategoryWiseProduct(category);
        setLoading(false);
        setData(categoryProduct?.data);
    }, [category]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return (
        <div className='container mx-auto py-12'>
            <div className='flex items-end justify-between mb-8'>
                <div className='space-y-1'>
                    <p className='text-xs font-bold uppercase tracking-[0.2em] text-accent'>Related</p>
                    <h2 className='text-3xl font-black text-primary tracking-tight'>{heading}</h2>
                </div>
            </div>

            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6'>
                {loading ? (
                    loadingList.map((_, index) => (
                        <div key={index} className='bg-white rounded-card shadow-sm border border-surface-border flex flex-col p-4 animate-pulse'>
                            <div className='h-48 bg-surface-muted rounded-premium mb-4' />
                            <div className='space-y-3'>
                                <div className='h-6 bg-surface-muted rounded' />
                                <div className='h-4 bg-surface-muted rounded w-1/2' />
                                <div className='h-10 bg-surface-muted rounded-full mt-2' />
                            </div>
                        </div>
                    ))
                ) : (
                    data.map((product, index) => (
                        <motion.div
                            key={product?._id}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            viewport={{ once: true }}
                        >
                            <div className='bg-white rounded-card shadow-premium hover:shadow-premium-hover border border-surface-border overflow-hidden transition-all duration-300 group'>
                                <Link to={"/product/" + product?._id} className='relative h-64 bg-surface-muted flex items-center justify-center p-8 overflow-hidden' onClick={scrollTop}>
                                    <img 
                                        src={product?.productImage[0]} 
                                        className='h-full object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-110' 
                                        alt={product?.productName}
                                    />
                                    {product?.price > product?.sellingPrice && (
                                        <div className='absolute top-4 left-4 bg-accent text-white text-[10px] font-black px-2 py-1 rounded-full uppercase tracking-wider'>
                                            Sale
                                        </div>
                                    )}
                                </Link>
                                
                                <div className='p-6 flex flex-col'>
                                    <p className='text-[10px] font-extrabold text-gray-400 uppercase tracking-widest mb-1'>{product?.category}</p>
                                    <Link to={"/product/" + product?._id} onClick={scrollTop}>
                                        <h3 className='font-bold text-lg text-primary line-clamp-2 hover:text-accent transition-colors leading-snug mb-3 h-14'>
                                            {product?.productName}
                                        </h3>
                                    </Link>
                                    
                                    <div className='flex items-baseline gap-2 mb-6'>
                                        <span className='text-xl font-black text-primary'>{displayNPRCurrency(product?.sellingPrice)}</span>
                                        {product?.price > product?.sellingPrice && (
                                            <span className='text-xs text-gray-400 line-through'>{displayNPRCurrency(product?.price)}</span>
                                        )}
                                    </div>

                                    {!userLoading && user?._id && (
                                        <button 
                                            onClick={(e) => handleAddToCart(e, product?._id)}
                                            className='flex items-center justify-center gap-2 h-11 bg-primary text-white text-xs font-bold rounded-full hover:bg-accent transition-all active:scale-95 shadow-lg shadow-primary/10'
                                        >
                                            <FaPlus /> Add to Cart
                                        </button>
                                    )}
                                </div>
                            </div>
                        </motion.div>
                    ))
                )}
            </div>
        </div>
    );
};

export default CategroyWiseProductDisplay;
